import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import heroImage from '@/assets/hero-living-room.webp';

export function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Beautiful living room with custom window shutters and natural light"
          className="w-full h-full object-cover"
          fetchPriority="high"
          width={1534}
          height={1080}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent" />
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 pt-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 bg-sage-light text-sage rounded-full text-sm font-medium mb-6 animate-fade-in-up">
            Serving Phoenix for Over 30 Years
          </span>
          
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6 animate-fade-in-up animation-delay-100">
            Transform Your Home with
            <span className="text-primary block">Custom Window Coverings</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed animate-fade-in-up animation-delay-200">
            Customizable shades, shutters, blinds and sunscreens expertly designed, 
            measured, and personally installed by our father-son team in the West Valley.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-300">
            <Button variant="default" size="lg" asChild>
              <a href="/#contact" className="gap-2">
                Free Same Day Estimates
                <ArrowRight className="w-5 h-5" />
              </a>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a href="/#products">Explore Products</a>
            </Button>
          </div>
          
          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 mt-12 pt-8 border-t border-border/50 animate-fade-in-up animation-delay-400">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-sage-light flex items-center justify-center">
                <span className="text-sage font-display font-bold text-lg">30+</span>
              </div>
              <div className="text-sm">
                <div className="font-semibold text-foreground">Years</div>
                <div className="text-muted-foreground">Experience</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-sage-light flex items-center justify-center">
                <span className="text-sage font-display font-bold text-lg">★</span>
              </div>
              <div className="text-sm">
                <div className="font-semibold text-foreground">5-Star</div>
                <div className="text-muted-foreground">Reviews</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-sage-light flex items-center justify-center">
                <span className="text-sage font-display font-bold text-lg">✓</span>
              </div>
              <div className="text-sm">
                <div className="font-semibold text-foreground">Free</div>
                <div className="text-muted-foreground">Installation</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <div className="w-6 h-10 border-2 border-foreground/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-foreground/50 rounded-full animate-fade-in" />
        </div>
      </div>
    </section>
  );
}
